<template>
    <div class="secret-btns">
        <div class="callBtnForm" @click="openFormModal">
            <svg-icon icon-class="phone-call" className="icon-phone-call"/>
        </div>
        <div class="top-btn"  
            v-scroll-to="{
                el: '#section-index-promo',
                offset: 0
            }"
        >
            <div class="in"><svg-icon icon-class="arrow-top" className="icon-arrow-top"/></div>
            <small>вверх</small>
        </div>
    </div>  
</template>


<script>
    
    export default {
        name: 'secret-btns',
        components: {
        },
        data () {
            return {
                
            }
        },
        methods: {
            openFormModal() {
                this.$store.commit('Open_Form_Modal', true);
            }
        },
        created () {
        },
        mounted() {
        }
    }
</script>